<script lang="ts" setup>
import { computed, defineAsyncComponent } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useHead } from '@unhead/vue';
import { useAppStore } from './stores';
import { PageHeader } from './components/page-header';
import { PageFooter } from './components/page-footer';

const appStore = useAppStore();
const route = useRoute();
const {
  siteTitle,
  siteDescription,
  siteSeo,
  siteLogoUrl,
} = storeToRefs(appStore);

const defaultTitle = '开源法律社区';
const websiteTitle = computed(() => siteTitle.value || siteSeo.value?.title || defaultTitle);
const routeTitle = computed(() => (typeof route.meta.title === 'string' ? route.meta.title : ''));

useHead({
  title: routeTitle,
  titleTemplate: (title) => {
    if (title) {
      return `${title} - ${websiteTitle.value}`;
    }

    return siteSeo.value?.title || websiteTitle.value;
  },
  meta: [
    {
      name: 'description',
      content: computed(() => siteSeo.value?.description || siteDescription.value || ''),
    },
    {
      name: 'keywords',
      content: computed(() => siteSeo.value?.keywords.join(',') || ''),
    },
    {
      property: 'og:image',
      content: computed(() => siteLogoUrl.value || ''),
    },
  ],
});

const Toaster = defineAsyncComponent(() =>
  import('./components/ui/sonner').then(({ Toaster }) => Toaster),
);
</script>

<template>
  <div class="flex min-h-dvh flex-col">
    <PageHeader />

    <main class="flex-1">
      <RouterView v-slot="{ Component }">
        <Component :is="Component" />
      </RouterView>
    </main>

    <PageFooter />
  </div>

  <ClientOnly>
    <Toaster />
  </ClientOnly>
</template>
